module.exports = __webpack_public_path__ + "static/media/mylogo.08878e62.jpg";